module.exports = __webpack_public_path__ + "img/02.0879f41c.png";